(() => {
  'use strict';
  if (window.__phUXDispatchV38Loaded) return;
  window.__phUXDispatchV38Loaded = true;


  const localeMap = {
    nl: 'nl-NL',
    de: 'de-DE',
    fr: 'fr-FR',
    pl: 'pl-PL',
    en: 'en-GB'
  };
  function languageCode() {
    const raw = (document.documentElement.lang || 'nl').toLowerCase();
    const code = raw.slice(0, 2);
    return localeMap[code] ? code : 'nl';
  }

  function renderDeliveryEstimates() {
    const elements=document.querySelectorAll('[data-ph-delivery-estimate]');if(!elements.length)return;
    elements.forEach(element=>{
      const target=element.querySelector('[data-ph-shipping-date]');if(!target)return;
      const available=element.dataset.phAvailable!=='0';
      const message=available?element.dataset.phDeliveryText||'':'';
      if(target.textContent!==message)target.textContent=message;
    });
  }

  function initDispatchUpdates() {
    let frame = 0;
    const refresh = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        renderDeliveryEstimates();
      });
    };
    ['themeVariantUpdated', 'themeCartUpdated', 'themeCartOpened', 'shopify:section:load', 'phCartRecommendationsLoaded'].forEach((name) => {
      document.addEventListener(name, refresh);
      window.addEventListener(name, refresh);
    });
    // Catch cards inserted by filtering, search, recommendations and infinite scrolling.
    if (window.MutationObserver && document.body) {
      new MutationObserver((records) => {
        const hasNewEstimate = records.some((record) => Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches('[data-ph-delivery-estimate]') || node.querySelector('[data-ph-delivery-estimate]'))
        ));
        if (hasNewEstimate) refresh();
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    window.addEventListener('pageshow', refresh);
    window.addEventListener('focus', refresh);
  }

  function formatCurrencyCents(cents, currency) {
    const code = languageCode();
    const locale = localeMap[code] || 'nl-NL';
    const value = Math.max(0, Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(value);
    } catch (error) {
      return `€${value.toFixed(2).replace('.', ',')}`;
    }
  }

  function smartUpsellScore(price, gap) {
    if (!Number.isFinite(price) || price <= 0) return Number.MAX_SAFE_INTEGER;
    const distance = Math.abs(price - gap);
    const undershootPenalty = price < gap ? Math.max(600, gap * 0.8) : 0;
    const overshootPenalty = price > gap * 2.5 && gap > 0 ? (price - gap * 2.5) * 0.35 : 0;
    return distance + undershootPenalty + overshootPenalty;
  }

  function applySmartCartUpsell(element) {
    if (!element || !element.classList || !element.classList.contains('cart-upsell')) return;
    const list = element.querySelector('.l4ca');
    const heading = element.querySelector('h3');
    if (!list) return;

    const cards = Array.from(list.children).filter((card) => card.matches('li[data-product-id]'));
    if (!cards.length) return;

    const gap = Math.max(0, parseInt(element.dataset.phGap || '0', 10) || 0);
    const currency = element.dataset.phCurrency || 'EUR';
    let ordered = cards.slice();

    cards.forEach((card) => card.classList.remove('ph-smart-hidden'));

    if (gap > 0) {
      ordered.sort((a, b) => {
        const priceA = parseInt(a.dataset.phPrice || '0', 10) || 0;
        const priceB = parseInt(b.dataset.phPrice || '0', 10) || 0;
        return smartUpsellScore(priceA, gap) - smartUpsellScore(priceB, gap);
      });
      element.classList.add('ph-smart-gap');
      if (heading && element.dataset.phGapHeading) {
        heading.textContent = element.dataset.phGapHeading.replace('__PH_AMOUNT__', formatCurrencyCents(gap, currency));
      }
    } else {
      element.classList.remove('ph-smart-gap');
    }

    const selected = new Set(ordered.slice(0, 3));
    ordered.slice(0, 3).forEach((card) => list.appendChild(card));
    cards.forEach((card) => {
      if (!selected.has(card)) card.classList.add('ph-smart-hidden');
    });
  }

  function initSmartCartUpsell() {
    document.querySelectorAll('.cart-upsell').forEach(applySmartCartUpsell);
  }

  window.addEventListener('phCartRecommendationsLoaded', (event) => {
    applySmartCartUpsell(event.detail && event.detail.element ? event.detail.element : null);
  });
  window.addEventListener('themeCartOpened', () => {
    window.setTimeout(initSmartCartUpsell, 0);
  });

  function init() {
    renderDeliveryEstimates();
    initDispatchUpdates();
    initSmartCartUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

})();
